import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CardModal from './CardModal';
import { API_URL } from '../config';

function CardGallery({ user, token }) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedCard, setSelectedCard] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [cardTypeFilter, setCardTypeFilter] = useState('');

  useEffect(() => {
    fetchCards();
  }, []);

  const fetchCards = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/cards`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      setCards(response.data);
    } catch (error) {
      setError('Errore nel caricamento delle carte');
      console.error('Error fetching cards:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredCards = cards.filter(card => {
    const metadata = card.metadata ? (typeof card.metadata === 'string' ? JSON.parse(card.metadata) : card.metadata) : {};
    
    // Search filter
    const matchesSearch = card.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
           (metadata.type && metadata.type.toLowerCase().includes(searchTerm.toLowerCase()));
    
    // Card type filter
    let matchesType = true;
    if (cardTypeFilter) {
      const cardAttribute = metadata.attribute || '';
      switch (cardTypeFilter) {
        case 'trap':
          matchesType = cardAttribute.toLowerCase() === 'trap';
          break;
        case 'magic':
          matchesType = cardAttribute.toLowerCase().includes('magic') || cardAttribute.toLowerCase().includes('spell');
          break;
        case 'monster':
          matchesType = cardAttribute.toLowerCase() !== 'trap' && 
                       !cardAttribute.toLowerCase().includes('magic') && 
                       !cardAttribute.toLowerCase().includes('spell') &&
                       cardAttribute.toLowerCase() !== '';
          break;
        default:
          matchesType = true;
      }
    }
    
    return matchesSearch && matchesType;
  });

  if (loading) {
    return (
      <div className="container">
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <h2>Caricamento carte...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <div className="gallery-header-top">
          <h2>📚 Raccolta Carte</h2>
          <div className="search-container">
            <input
              type="text"
              placeholder="Cerca carte brutte..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>
        <div className="filter-buttons">
          <button 
            className={`filter-btn ${cardTypeFilter === '' ? 'active' : ''}`}
            onClick={() => setCardTypeFilter('')}
          >
            Tutte
          </button>
          <button 
            className={`filter-btn ${cardTypeFilter === 'monster' ? 'active' : ''}`}
            onClick={() => setCardTypeFilter('monster')}
          >
            🐲 Mostri
          </button>
          <button 
            className={`filter-btn ${cardTypeFilter === 'magic' ? 'active' : ''}`}
            onClick={() => setCardTypeFilter('magic')}
          >
            ✨ Magie
          </button>
          <button 
            className={`filter-btn ${cardTypeFilter === 'trap' ? 'active' : ''}`}
            onClick={() => setCardTypeFilter('trap')}
          >
            🪤 Trappole
          </button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="cards-clean-grid">
        {filteredCards.map(card => {
          return (
            <div key={card.id} className="card-clean" onClick={() => setSelectedCard(card)}>
              <span className={`owner-chip ${card.owner_username ? '' : 'free'}`}>
                {card.owner_username || 'Libera'}
              </span>
              {card.jpeg_filename && (
                <img 
                  src={`${API_URL}/cards/${card.jpeg_filename}`}
                  alt={card.name}
                  className="card-clean-image"
                />
              )}
            </div>
          );
        })}
      </div>

      {filteredCards.length === 0 && !loading && (
        <div className="no-results">
          <p>Nessuna carta trovata</p>
        </div>
      )}

      {selectedCard && (
        <CardModal 
          card={selectedCard} 
          onClose={() => setSelectedCard(null)} 
        />
      )}
    </div>
  );
}

export default CardGallery;